import { DashboardWidget } from './dashboard_widget';

export const DASHBOARD_COLUMNS = 12;

export type Dashboard = {
  id: string;
  application_id: string;
  name: string;
  configuration: DashboardConfiguration;
  created_at: string;
  updated_at: string;
};

export type DashboardConfiguration = { widgets: DashboardWidget[] };
